<div
  class="marker-container"
  [attr.data-state]="state"
  [umssTooltip]="tooltip"
  [attr.data-disabled]="disabled"
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    class="marker-icon"
  >
    <circle cx="7" cy="7" r="6.5" fill="white" stroke="#03045E" />
  </svg>
</div>
